export default __webpack_public_path__ + "static/media/Group9235.6a7a6560.svg";